import request from '@/utils/request'

export function login(params) {
  return request({
    url: '/auth/wecomLogin',
    method: 'post',
    data: params
  });
}

export function getUserInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  });
}

export function updateProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data
  });
}

export function sidelineLogin(params) {
  return request({
    url: '/auth/wecomLogin',
    method: 'post',
    data: params
  });
}


export function getWxJsapiSignature(params) {
  return request({
    url: '/getWxJsapiSignature',
    method: 'post',
    params: params
  });
}

export function getJsapiTicket(params) {
  return request({
    url: '/getJsapiTicket',
    method: 'get',
    params: params
  });
}

export function getAgentJsapiTicket(params) {
  return request({
    url: '/getAgentJsapiTicket',
    method: 'get',
    params: params
  });
}